/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'


const basePath = '/membership/rentals'
const specPath = '/membership/rentals-specifications'

const RentalsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchRentals: builder.query<any, any>({
      query: () => `${basePath}`,
      providesTags:['rentals']
    }),

    createRental: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['rentals']
    }),

    deleteRental: builder.mutation<any, any>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['rentals'],
    }),
    updateRentals: builder.mutation<any, any>({
      query: ({id, body}) => ({
        url: `${basePath}/${id}`,
        method: 'put',
        body,
      }),
      invalidatesTags: ['rentals'],
    }),

    addSpecification: builder.mutation<any, any>({
      query: ({body, id}) => ({
        url: `${specPath}?rentalId=${id}`,
        method: 'post',   
        body, 
      }),
      invalidatesTags: ['rentals'],
    }),
    deleteSpecification: builder.mutation<any, any>({
      query: (id) => ({
        url: `${specPath}?id=${id}`,
        method: 'delete',
      }), 
      invalidatesTags: ['rentals'],
    }),

    useUploadRentalImage: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}/images`,  
        method: 'post',
        body,
      }),
      invalidatesTags: ['rentals'],
    }),
    deleteRentalImage: builder.mutation<any, any>({
      query: (id) => ({
        url: `${basePath}/images?id=${id}`, 
        method: 'delete',
      }),
      invalidatesTags: ['rentals'],
    }),
  })

export default RentalsEndpoints
